import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Path,
        {
          d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Shield";
const Shield = memo(themed(Icon));
export {
  Shield
};
//# sourceMappingURL=shield.js.map
